import React from "react";
import { translateSingleStat } from "./SkillsParser.js";

declare global {
    interface Window {
        MargoSkillsParser?:  {
            getStats(stat: string): string[];
            getRegs(stat: string): string[];
        }
        _t: any;
        _t2: any;
        Engine: any;
    }
}

if (window.MargoSkillsParser) {
    // Their code is still garbage.
    window.Engine = {
        hero: {
            d: {
                prof: "w",
                lvl: 300
            }
        }
    }
}

const weaponNames: Record<string, string> = {
    "sw": "Broń biała",
    "1h": "Broń jednoręczna",
    "2h": "Broń dwuręczna",
    "bs": "Broń półtoraręczna",
    "h": "Broń pomocnicza",
    "dis": "Broń dystansowa",
    "fire": "Broń zadająca obrażenia od ognia",
    "light": "Broń zadająca obrażenia od błyskawic",
    "frost": "Broń zadająca obrażenia od zimna",
    "sh": "Tarcza",
    "poison": "Broń zadająca obrażenia od trucizny",
    "phydis": "Broń dystansowa zadająca obrażenia w pełni fizyczne",
    "wound": "Broń zadająca obrażenia od głębokiej rany"
}

export function translateRequirement(name: string, value: string) {
    // MargoSkillsParser getreqs sucks ASS
    switch(name) {
        case "reqw": {
            let res: string[] = [];
            const spl = value.split(",");
            for (const wpn of spl) {
                res.push(weaponNames[wpn] ?? `Nieznany typ broni: ${value}`);
            }
            return res.join(", ");
        }
        case "reqp": // Hide required prof
        default:
            return "";
    }
}

function parseLevelScaling(value: string, lvl: number) {
    return value.replace(/([0-9]+(\.[0-9]+)?)\*(c?plvl)/g, (match, val, _, scalingType) => {
        const v = Number(val) * (scalingType == "cplvl" ? Math.min(lvl, 300) : lvl);
        return String(Math.round(v)) + `*${scalingType}`; // TODO: verify rounding
    });
}

const abhorrentRegex = /([+-])?<span class="damage">(.*?)(punktów procentowych)?<\/span>(%)?/g;

export function translateStat(name: string, value: string, playerLvl: number) {
    const scaledValue = parseLevelScaling(value, playerLvl);
    return `- ` + translateSingleStat(name, scaledValue, "");// + ` (${name}=${value})`;
    // if (window.MargoSkillsParser?.getStats) {
        // const t = window._t;
        // window._t = window._t2;
        // const html = window.MargoSkillsParser.getStats(`${name}=${scaledValue}&`).join("");
        // window._t = t;
        // return html.replace(abhorrentRegex, (match, optionalSign, content, perPointsString, optionalPercent) => {
            // const sign = optionalSign ?? "";
            // const per = optionalPercent ? "%" : "";
            // const perPoints = perPointsString ?? "";
            // return `<span class="damage">${sign}${content}${per}</span>${perPoints}`;
        // });
    // } else {
        // return `${name}=${scaledValue}`;
    // }
}